import { FieldType, O } from "../../../features/ui"
import { useDataTypesHooks } from "../../../features/data-types"
import { useUnitTypeLoaders } from "../../stock"
import { Measure } from "../state/types"

export const useMeasureHooks = () => {
    const { formatValue } = useDataTypesHooks()

    const unitTypeLoaders = useUnitTypeLoaders()

    const describeMeasure = (measureData: Partial<Measure>) => {
        const { units, unitTypeId } = measureData
        const { findUnitType } = unitTypeLoaders()
        const unitType = findUnitType(unitTypeId! as string)!
        return `${formatValue(units! as number, FieldType.NUMBER)} ${unitType.abbreviation}`
    }

    return {
        describeMeasure
    }
}
